import { useEffect, useRef } from 'react'
import { realtime, type RealtimeEvent } from '../api/realtime'
import { useOrganization } from '../contexts/OrganizationContext'

/**
 * Live events for the organisation on screen. The socket carries every organisation
 * the person belongs to, so events for the others are dropped here.
 */
export function useRealtime(onEvent: (event: RealtimeEvent) => void, enabled = true) {
  const { organization } = useOrganization()
  const handler = useRef(onEvent)
  handler.current = onEvent
  const slug = organization?.slug

  useEffect(() => {
    if (!enabled) return
    return realtime.subscribe((event) => {
      if (event.type !== 'resync' && slug && event.organization !== slug) return
      handler.current(event)
    })
  }, [enabled, slug])
}
